export function highlightMatch(text, query, minChars = 3) {
  if (!query || query.length < minChars) return text

  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(`(${escapedQuery})`, "gi")

  return text.replace(regex, '<strong class="searcher__highlight">$1</strong>')
}